import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack, Typography } from '@mui/material';

type PropTypes = {
  close: () => void;
  open: boolean;
  message?: string;
  title?: string;
};

export const CustomMessageDialog = ({
  close,
  open,
  message,
  title,
}: PropTypes) => {
  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>
        <Typography variant="h5" textAlign={'center'}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Stack spacing={3}>
          <Typography>{message}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
